/**
 * Insiders API Request Functions
 * Handles SSO token operations for Insider Plus authentication
 */

import { getRequest, postRequest } from './index';
import apiEndpoints from './apiEndpoints';

/**
 * Issue a new SSO token for the current authenticated user
 * @returns {Promise} SSO token response
 */
export const issueSsoToken = () =>
  getRequest(apiEndpoints.insiders.issueSsoToken);

/**
 * Validate an SSO token
 * @param {string} ssoToken - The SSO token to validate
 * @returns {Promise} Validation response
 */
export const validateSsoToken = (ssoToken) =>
  postRequest(apiEndpoints.insiders.validateSsoToken, { ssoToken });
